import { MALE, FEMALE} from '@/constants/genders'
import { helpers, minLength, required } from 'vuelidate/lib/validators'

export const gender = (value) => value === MALE || value === FEMALE
export const phone = helpers.regex('phone', /^\d+$/)
/* export const password = helpers.regex('password', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬])[A-Za-z\d@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬]{8,}$/) */
export const onlyTrue = (value) => value === true
export const afterToday = (value) => new Date(value) > new Date()
export const afterDate = (date) => helpers.withParams(
  { type: 'sameAs', value: date },
  (value, parentVm) => new Date(value) > new Date(helpers.ref(date, this, parentVm))
)
export const onlyText = helpers.regex('onlyText', /^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/)
export const hasNumber = helpers.regex('hasNumber', /\d/)
export const hasUpperCase = helpers.regex('hasUpperCase', /[A-Z]/)
export const hasLowerCase = helpers.regex('hasLowerCase', /[a-z]/)
export const hasSpecialChar = helpers.regex('hasSpecialCharacter', /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)

export const password = {
  required,
  minLength: minLength(8),
  hasNumber: hasNumber,
  hasUpperCase: hasUpperCase,
  hasLowerCase: hasLowerCase,
  hasSpecialChar: hasSpecialChar
}


// WEBPACK FOOTER //
// ./src/plugins/customValidators.js